import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { post, get } from "../../../service/api";
import { IUserPrefrencesDto } from "../interface/dto/user-preferences.dto";

export const getUserPreferences = (
    tokens: ITokenPair,
): Observable<IUserPrefrencesDto> =>
    get<IUserPrefrencesDto>("/user-preferences", undefined, tokens);

export const updateUserPreferences = (
    payload: IUserPrefrencesDto,
    tokens: ITokenPair,
): Observable<boolean> =>
    post<boolean>("/user-preferences", payload, undefined, tokens);
